import styled, { css } from 'styled-components';
import { Colors } from '../../../ui';

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 auto;
    padding: 0 1.5rem;    
    border-bottom: solid 1px ${Colors.borderLight};
`;

const Section = styled.div<{ grow?: boolean, end?: boolean }>`
    display: flex;
    flex-direction: column;
    flex: ${p => p.grow ? 1 : 0} 1 auto;    
    gap: 1.5rem;
    ${p => !p.end && css`
        padding: 1.5rem 1rem 1.5rem 1.5rem;
    `}
    ${p => p.end && css`
        padding: .5rem;
    `}
`;

const Advert = styled.div`
    flex: 0 0 auto;
    padding: .5rem;
`;

const Footer = styled.div`
    flex: 0 0 auto;
    border-top: solid 1px ${Colors.borderLight};
`;

const Divide = styled.div`
    flex: 0 0 auto;
    border-top: solid 1px ${Colors.borderLight};
`;

const Frame = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;    
`;

export const Navigation = Object.assign(Frame, {
    Header,
    Section,
    Advert,
    Divide,
    Footer
});
